export const BMC_PRICING = {
  PREMIUM: {
    AMOUNT: "500",
    LINK: "https://rzp.io/rzp/enfaAIJK"
  },
  PREMIUM_PLUS: {
    AMOUNT: "850",
    LINK: "https://rzp.io/rzp/snmc3qo"
  },
}